"use client";

import { UserRound } from "lucide-react";
import { LogoutButton } from "@/shared/ui/logout-button";
import { useAuth } from "@/core/auth/use-auth";

export function CurrentSessionSummary() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="rounded-[1.5rem] border border-slate-200 bg-white/80 p-6 text-sm text-slate-500">
        Loading session details...
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-white/85 p-6 shadow-sm">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-sm font-medium text-slate-500">
            <UserRound className="size-4" />
            Signed in
          </div>
          <div>
            <div className="text-lg font-semibold text-slate-950">{user.name}</div>
            <div className="text-sm text-slate-500">{user.email}</div>
          </div>
          <p className="max-w-xl text-sm leading-6 text-slate-600">
            Your secure ItsHealer session is active on this device.
          </p>
        </div>
        <LogoutButton />
      </div>
    </div>
  );
}
